import React, { useContext } from 'react';
import ValueContext from './Context';

export default function PremiumChanger() {
  const { premium, changePremium } = useContext(ValueContext);

  function handlePremiumChange(e) {
    if (e.target.value === 'basic') {
      changePremium(false);
    } else {
      changePremium(true);
    }
  }

  return (
    <>
      <span className='RadioButtonPremium1'>
        <input
          type='radio'
          id='premChoice1'
          name='prem'
          value='basic'
          checked={!premium}
          onChange={handlePremiumChange}
        />
        <label className='RadioLabel' htmlFor='premChoice1'>
          Basic
        </label>
      </span>
      <span className='RadioButtonPremium2'>
        <input
          type='radio'
          id='premChoice2'
          name='prem'
          value='premium'
          checked={premium}
          onChange={handlePremiumChange}
        />
        <label className='RadioLabel' htmlFor='premChoice2'>
          Premium
        </label>
      </span>
    </>
  );
}
